import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "my-3 text-center sm:mt-0 sm:text-left flex flex-wrap gap-4 items-center justify-between border-b border-gray-200 pb-4" }
const _hoisted_4 = { class: "mt-4 w-full" }


import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  showModal: {
    type: Boolean,
    required: true,
  },
  modalTitle: {
    type: String,
    required: true,
  },
  fitContent: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["close-modal"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: props.showModal
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-modal')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative transform overflow-auto rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-11/12 sm:max-w-5xl sm:p-6 max-h-[calc(100vh-200px)]" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg font-semibold leading-6 text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.modalTitle), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("i", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-modal'))),
                          class: "text-2xl font-bold fas fa-close cursor-pointer"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "default")
                      ])
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})